var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{ref:"chart",attrs:{"lib":"highcharts","dataforce":""},model:{value:(_vm.chartData),callback:function ($$v) {_vm.chartData=$$v},expression:"chartData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }